import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';

import { ReactComponent as GiftItDigitallyIcon } from '@/assets/4gift-gift-it-digitally.svg';

import * as S from '../SendGiftModal.styles';

export const GiftItDigitally = () => {
  const { formatMessage } = useIntl();
  return (
    <S.InfoBoxBody>
      <GiftItDigitallyIcon />
      <Typography
        fontFamily='italianPlate'
        fontWeight='bold'
        mb='s035'
        mt='s035'
        scale='p0'
        textTransform='uppercase'
      >
        {formatMessage(commonMessages.sendGiftGiftDigitally)}
      </Typography>
      <Typography textAlign='center'>
        {formatMessage(commonMessages.sendGiftGiftDigitallyDesc)}
      </Typography>
    </S.InfoBoxBody>
  );
};
